import { illegalUrls } from "@/data/illegalUrls";
import { TranslateResult } from "vue-i18n";

type ErrorMessage = string | TranslateResult;

const validPhone = /^[0-9+() -]{1,100}$/;
const validEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const urlSafeRegex = /^[a-zA-Z0-9_-]*$/;

export const requiredValidator = (
  value: string | boolean,
  errMsg: ErrorMessage
): TranslateResult | null => {
  if (typeof value === "boolean") {
    return value ? null : errMsg;
  }

  if (!value || value.length === 0) {
    return errMsg;
  }

  return null;
};

export const minLengthValidator = (
  value: string,
  errMsg: ErrorMessage,
  minLength = 12
): TranslateResult | null => {
  if (value.length < minLength) {
    return errMsg;
  }

  return null;
};

export const maxLengthValidator = (
  value: string,
  errMsg: ErrorMessage,
  maxLength = 120
): TranslateResult | null => {
  if (value.length > maxLength) {
    return errMsg;
  }

  return null;
};

export const phoneNumberValidator = (value: string, errMsg: ErrorMessage) => {
  return validPhone.test(value) ? null : errMsg;
};

export const emailValidator = (value: string, errMsg: ErrorMessage) => {
  return validEmailRegex.test(value) ? null : errMsg;
};

export const companyUrlValidator = (value: string, errMsg: ErrorMessage) => {
  const isIllegalUrl = illegalUrls.some(
    u => value.toLowerCase() === u.toLowerCase()
  );

  if (!urlSafeRegex.test(value) || isIllegalUrl) {
    return errMsg;
  }

  return null;
};
